import { render, staticRenderFns } from "./XAdminProject.vue?vue&type=template&id=767f0696&scoped=true"
import script from "./XAdminProject.vue?vue&type=script&lang=js"
export * from "./XAdminProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f0696",
  null
  
)

export default component.exports